import axios from 'axios';
import { baseURL, myEpikBaseURL, unifiedBaseURL } from './api';
import store from '../../store';
import utils from '../utils';
const url = require('url');

const apiVersion = 'v2';
export const path = process.env.REACT_APP_BASE_URL + '/api/';
class OobmService {
  static baseURL = baseURL;

  static resourcePath = path || '';

  constructor(api, demo = false, baseURLOverride) {
    this.api = api;
    this.demo = demo;
    this.baseURL = baseURLOverride;
  }

  getBaseURL = myEpik => {
    const urlObj = url.parse(document.location.href, true);
    // const dev =
    //   urlObj.href.indexOf('my.epik.io') !== -1 ||
    //   urlObj.href.indexOf('mytest.epik.io') !== -1 ||
    //   urlObj.href.indexOf('mytestapi.epik.io') !== -1;
    const { isBoxTab } = store.getState()?.UIState?.globals;

    // if (!dev) {
    //   return this.baseURL || NumberService.resourcePath || NumberService.baseURL;
    // }
    if (myEpik || global.myEpik === 'Yes') {
      return myEpikBaseURL;
    }
    if (global.myEpik === 'No') {
      if (!isBoxTab) return myEpikBaseURL;
      return unifiedBaseURL();
      // return this.baseURL || NumberService.resourcePath || NumberService.baseURL;
    }
    return this.baseURL || OobmService.resourcePath || OobmService.baseURL;
  };

  getPaginateOptions = options => {
    return JSON.stringify(options || { page: 1, limit: 10 });
  };

    async getOobmBox() {
      const headers = {
        Authorization: `Bearer ${this.api.token}`,
      };
  
      const { data } = await axios.get(
        `${this.getBaseURL()}${apiVersion}${path}/v2/oob/getAllOobm`,
        {
          headers,
        },
      );
      return data;
    }
}

export default OobmService;
